import {
  ME_SUCCESS,
  SET_TOKEN,
  LOGIN_SUCCESS,
  EDIT_PROFILE_SUCCESS,
  SET_BIG_COMMERCE_URL,
  SIGN_OUT
} from "../actions";

const initialState = {
  locale: "en",
  isAuthenticated: false,
  user: {},
  bigCommerceUrl: "",
  token: {}
};

const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOGIN_SUCCESS: {
      // Strictly require new API contract
      if (!action.payload?.data?.user?.id || !action.payload?.data?.token) {
        throw new Error('API Contract Violation: Expected payload.data.user.id and payload.data.token');
      }
      return {
        ...state,
        isAuthenticated: true,
        user: {
          ...action.payload.data.user,
          id: action.payload.data.user.id,
          multipassUrl: action.payload.data.multipassUrl,
          multipassUrlExpiry: action.payload.data.multipassUrlExpiry,
          token: action.token,
          region: action.payload.data.user.realm || 'US'
        },
        token: {
          id: action.payload.data.token,
          userId: action.payload.data.user.id
        }
      };
    }

    case SET_TOKEN:
      return {
        ...state,
        token: action.token,
      };
    case ME_SUCCESS:
      return {
        ...state,
        isAuthenticated: true,
        user: {
          ...state.user,
          ...action.payload,
          // Preserve these values if they exist in the current state
          multipassUrl: state.user?.multipassUrl || action.payload?.multipassUrl,
          multipassUrlExpiry: state.user?.multipassUrlExpiry || action.payload?.multipassUrlExpiry,
        },
      };
    case EDIT_PROFILE_SUCCESS:
      return {
        ...state,
        user: {
          ...state.user,
          ...action.payload,
        },
      };
    case SET_BIG_COMMERCE_URL:
      return {
        ...state,
        bigCommerceUrl: action.payload
      };
    case SIGN_OUT:
      // Reset the state when user logs out
      return {
        ...initialState
      };
    default:
      return state;
  }
};

export default authReducer;
